let cancelScroll = () => {};

export const scrollToAnchor = (event) => {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target.closest('a[href^="#"]');
  const target = link && document.getElementById(link.hash.slice(1));
  if (!target) return;

  event.preventDefault();
  cancelScroll();
  const start = window.scrollY;
  const left = window.scrollX;
  const maximum = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  const destination = Math.max(0, Math.min(start + target.getBoundingClientRect().top - 24, maximum));
  if (window.location.hash !== link.hash) window.history.pushState(null, '', link.hash);

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.scrollTo(left, destination);
    return;
  }

  // Numeric scroll coordinates avoid relying on native smooth-scroll support.
  const started = performance.now();
  let frame;
  const interrupts = ['wheel', 'touchstart', 'keydown'];
  const stop = () => {
    window.cancelAnimationFrame(frame);
    interrupts.forEach((type) => window.removeEventListener(type, stop));
    cancelScroll = () => {};
  };
  const step = (now) => {
    const progress = Math.min((now - started) / 450, 1);
    const eased = 1 - (1 - progress) ** 3;
    window.scrollTo(left, Math.round(start + (destination - start) * eased));
    if (progress < 1) frame = window.requestAnimationFrame(step);
    else stop();
  };
  cancelScroll = stop;
  interrupts.forEach((type) => window.addEventListener(type, stop, { passive: true }));
  frame = window.requestAnimationFrame(step);
};